import PicklistHandler from '~/services/filter-form-service/FilterHandlers/PicklistHandler';

export default class FormsBuilder {
  constructor() {
    this.setOverrides();
    this.formsFieldTypeHandlers = [new PicklistHandler(this.overrides)];
  }

  setOverrides() {
    this.overrides = [];
  }

  findHandler(property) {
    return this.formsFieldTypeHandlers.find((handler) => handler.canHandle(property));
  }

  buildForm(properties) {
    return this.createFormsFields(properties);
  }

  createFormsFields(filterProperties) {
    const formsFields = filterProperties.map((property) => this.createFormsField(property));
    return formsFields;
  }

  createFormsField(property) {
    // const fieldHandler = this.findHandler(property);
    // at the moment we have only picklist
    const fieldHandler = this.formsFieldTypeHandlers[0];
    return fieldHandler.handleField(property);
  }
}
